import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FieldProblem01Section from './components/FieldProblem01Section';
import FieldProblem02Section from './components/FieldProblem02Section';
import RootCauseSection from './components/RootCauseSection';
import SolutionSection from './components/SolutionSection';
import InstallationSection from './components/InstallationSection';
import ProcessComparisonSection from './components/ProcessComparisonSection';
import ComparisonSection from './components/ComparisonSection';
import PatentSection from './components/PatentSection';
import CostSavingsSection from './components/CostSavingsSection';
import SpecsSection from './components/SpecsSection';
import UseCasesSection from './components/UseCasesSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const HomePage = () => {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <FieldProblem01Section />
        <FieldProblem02Section />
        <RootCauseSection />
        <SolutionSection />
        <InstallationSection />
        <ProcessComparisonSection />
        <ComparisonSection />
        <PatentSection />
        <CostSavingsSection />
        <SpecsSection />
        <UseCasesSection />
        <CTASection />
      </main>
      <FooterSection />
    </div>
  );
};

export default HomePage;
